import { VisuallyHidden } from '@react-aria/visually-hidden';
import { useIntl } from 'react-intl';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAuth } from '@/context/auth/AuthProvider';
import messages from '@/messages/messages';
import { CalmAuthMethods } from '@/utils/privacyCookies';

import { FBIcon, Wrapper } from './styles';
import { FacebookAuthButtonProps, FacebookButtonProps } from './types';

const FacebookButton = ({
	className = '',
	buttonText,
	hideMessage = false,
	onClick,
}: FacebookButtonProps) => {
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();

	const getButtonCta = () => {
		if (buttonText) {
			return buttonText;
		}

		return authPrompt === 'login'
			? formatMessage(messages.facebookSignInMessage)
			: formatMessage(messages.continueFacebookSignupMessage);
	};

	const buttonCta = getButtonCta();
	const bgColor = 'white';
	const textColor = 'black';
	const borderColor = 'gray3';
	const iconColor = 'facebookBlue';

	return (
		<Wrapper
			backgroundColor={bgColor}
			className={className}
			contentAlignment="center"
			data-testid="facebook-button"
			onPress={onClick}
			role="link"
			$noPadding={hideMessage}
			textColor={textColor}
			borderColor={borderColor}
		>
			<FBIcon $noMargin={hideMessage} $iconColor={iconColor} />
			{hideMessage ? <VisuallyHidden>{buttonCta}</VisuallyHidden> : buttonCta}
		</Wrapper>
	);
};

const FacebookAuthButtonBrowser = (props: FacebookAuthButtonProps) => {
	const { className, buttonText, hideMessage, onAuthSuccess, marketingOptIn } = props;

	const { authenticate } = useAuth();

	const onClick = (): void => {
		authenticate({ authMethod: CalmAuthMethods.Facebook, marketingOptIn, onAuthSuccess });
	};

	return (
		<FacebookButton
			className={className}
			buttonText={buttonText}
			hideMessage={hideMessage}
			onClick={onClick}
		/>
	);
};

function FacebookAuthButton(props: FacebookAuthButtonProps) {
	return <FacebookAuthButtonBrowser {...props} />;
}

export default FacebookAuthButton;
